import apptsTypes from './appts.types'
import { takeLatest, put, all, call } from 'redux-saga/effects';
import { auth } from './../../firebase/utils';
import { handleAddAppt, handleFetchAppts, handleDeleteAppt, handleFetchAppt, handleFetchAllAppts, handleUpdateAppt } from './appts.helpers';
import { setAppts, setAppt, fetchApptsStart } from './appts.actions';

export function* addAppt({ payload }) {

	try {
	  const timestamp = new Date();
	  const  id  = auth.currentUser.uid
	  yield handleAddAppt(id,{
		...payload,
		createdDate: timestamp,
	  });
	  yield put(
		fetchApptsStart()
	  );
  
  
	} catch (err) {
	  console.log(err);
	}
  
}

export function* onAddServiceStart() {
	yield takeLatest(apptsTypes.ADD_NEW_APPT_START, addAppt);
}

export function* fetchAppts({ payload }) {
	try {
		const  id  = auth.currentUser.uid
	  const appts = yield handleFetchAppts(id, payload);
	  yield put(
		setAppts(appts)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchApptsStart() {
	yield takeLatest(apptsTypes.FETCH_APPTS_START, fetchAppts);
}

export function* fetchAllAppts({ payload }) {
	try {

	  const appts = yield handleFetchAllAppts( payload);
	  yield put(
		setAppts(appts)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchAllApptsStart() {
	yield takeLatest(apptsTypes.FETCH_ALL_APPTS_START, fetchAllAppts);
}

export function* updateAppt(
	{ payload: {
	startDate,
	productName,
	custsID,
	custName,
	vendorsID,
	vendorsName,
	custAddress,
	vendorsPhone,
	apptDetails,
	documentID
  } }) {

	try {
	const  id  = auth.currentUser.uid
	const appt = { 
		startDate,
		productName,
		custsID,
		custName,
		vendorsID,
		vendorsName,
		custAddress,
		vendorsPhone,
		apptDetails};
		yield handleUpdateAppt(id, documentID, appt);
		
	} catch (err) {
		alert(err)
	}
  }
  
  export function* onUpdateApptStart() {
	yield takeLatest(apptsTypes.UPDATE_APPT_START, updateAppt);
  }

export function* deleteAppt({ payload }) {
	try {
		const  id  = auth.currentUser.uid
	  yield handleDeleteAppt(id, payload);
	  yield put (
		fetchApptsStart()
	  );
  
	} catch (err) {
	}
  }
  
export function* onDeleteApptStart() {
	yield takeLatest(apptsTypes.DELETE_APPT_START, deleteAppt);
}

export function* fetchAppt({ payload }) {
	try {
	  const appt = yield handleFetchAppt(payload);
	  yield put(
		setAppt(appt)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchApptStart() {
	yield takeLatest(apptsTypes.FETCH_APPT_START, fetchAppt);
}

export default function* apptsSagas() {
	yield all([
	  call(onAddServiceStart),
	  call(onFetchApptsStart),
	  call(onUpdateApptStart),
	  call(onDeleteApptStart),
	  call(onFetchApptStart),
	  call(onFetchAllApptsStart)

	])
}